import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const esTranslations: PluginDefaultTranslationsObject = {
  $schema: './esquema-de-traducción.json',
  'plugin-form-builder': {
    name: 'Nombre (minúsculas, sin caracteres especiales)',
    add: 'Añadir',
    allowedFileTypes: 'Tipos de archivos permitidos',
    allowedFileTypesDescription:
      'Restrinja los tipos de archivos permitidos (por ejemplo, imagen/*, aplicación/pdf). Déjelo vacío para permitir todos los tipos.',
    allowMultipleFiles: 'Permitir múltiples archivos',
    amountInCents: 'Cantidad en centavos',
    basePrice: 'Precio base',
    bcc: 'BCC',
    brand: 'Marca',
    cc: 'CC',
    checkboxPlural: 'Campos de casilla de verificación',
    checkboxSingular: 'Casilla de verificación',
    checkedByDefault: 'Marcado por defecto',
    chooseConfirmationType:
      'Elija si desea mostrar un mensaje en la página o redirigir a una página diferente después de enviar el formulario.',
    condition: 'Condición',
    confirmationMessage: 'Mensaje de confirmación',
    confirmationType: 'Tipo de confirmación',
    countryPlural: 'Campos de país',
    countrySingular: 'País',
    creditCard: 'Tarjeta de crédito',
    customURL: 'URL personalizada',
    datePlural: 'Campos de fecha',
    dateSingular: 'Fecha',
    defaultValue: 'Valor predeterminado',
    divide: 'dividir',
    documentToLinkTo: 'Documento para vincular',
    doesNotEqual: 'No es igual',
    emailFrom: 'Correo electrónico de',
    emailPlural: 'Campos de correo electrónico',
    emailsDescription:
      'Envíe correos electrónicos personalizados cuando se envíe el formulario. Utilice listas separadas por comas para enviar el mismo correo electrónico a varios destinatarios. Para hacer referencia a un valor de este formulario, incluya el nombre de ese campo entre llaves dobles, es decir, {{firstName}}. Puede utilizar un comodín {{*}} para generar todos los datos y {{*:table}} para formatearlos como una tabla HTML en el correo electrónico.',
    emailSingular: 'Correo electrónico',
    emailTo: 'Enviar correo electrónico a',
    equals: 'igual',
    field: 'campo',
    fields: 'Campos',
    fieldWidth: 'Ancho de campo (porcentaje)',
    hasAnyValue: 'Tiene algún valor',
    internalLink: 'Enlace interno',
    label: 'Etiqueta',
    maxFileSize: 'Tamaño máximo de archivo (bytes)',
    maxFileSizeDescription: 'Tamaño máximo de archivo en bytes. Déjelo vacío sin límite.',
    message: 'Mensaje',
    messageDescription: 'Ingrese el mensaje que debe enviarse en este correo electrónico.',
    messagePlural: 'Bloques de mensajes',
    messageSingular: 'Mensaje',
    mimeType: 'Tipo MIME',
    mimeTypePlural: 'Tipos MIME',
    mimeTypeSingular: 'Tipo MIME',
    multiply: 'multiplicar',
    numberPlural: 'Campos numéricos',
    numberSingular: 'Número',
    optionPlural: 'Opciones',
    optionSingular: 'Opción',
    paymentFieldPlural: 'Campos de pago',
    paymentFieldSingular: 'Pago',
    paymentProcessor: 'Procesador de pagos',
    paymentStatus: 'Estado',
    placeholder: 'Marcador de posición',
    priceConditions: 'Condiciones de precio',
    priceConditionsPlural: 'Condiciones de precio',
    priceConditionsSingular: 'Condición del precio',
    radioOptions: 'Opciones de atributos de radio',
    radioPlural: 'Campos de radio',
    radioSingular: 'Radio',
    redirect: 'Redirigir',
    replyTo: 'Responder a',
    required: 'Requerido',
    selectOptions: 'Seleccionar opciones',
    selectPlural: 'Seleccionar campos',
    selectSingular: 'Seleccionar',
    statePlural: 'Campos estatales',
    stateSingular: 'Estado',
    staticValue: 'Valor estático',
    subject: 'Asunto',
    submitButton: 'Enviar etiqueta del botón',
    subtract: 'Restar',
    textareaPlural: 'Campos de área de texto',
    textareaSingular: 'área de texto',
    textPlural: 'Campos de texto',
    textSingular: 'Texto',
    title: 'Título',
    token: 'ficha',
    uploadCollection: 'Subir colección',
    uploadCollectionDescription: 'Seleccione en qué colección de carga almacenar archivos',
    uploadFieldPlural: 'Cargar campos',
    uploadFieldSingular: 'Subir',
    urlToRedirectTo: 'URL para redirigir a',
    value: 'Valor',
    valueOfField: 'Valor del campo',
    valueType: 'Tipo de valor',
  },
}

export const es: PluginLanguage = {
  dateFNSKey: 'es',
  translations: esTranslations,
}
